import styled from 'styled-components';

export const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 16px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};
`;

export const Card = styled.div`
  width: 100%;
  max-width: 560px;
  padding: 32px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  color: ${({ theme }) => theme.colors.surface.onSurface};

  p {
    line-height: 1.5;
  }
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 20px;
`;

export const Company = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin: 4px 0 12px;
`;

export const Muted = styled.p`
  font-size: 12px;
  margin: 4px 0 0;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Field = styled.div`
  margin: 16px 0;
`;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
`;

export const Declaration = styled.div`
  margin: 20px 0;
  line-height: 1.5;
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.danger.danger};
`;

export const Result = styled.p<{ $ok?: boolean }>`
  font-size: 14px;
  color: ${({ theme, $ok }) =>
    $ok ? theme.colors.success.success : theme.colors.surface.onSurface};
`;
